<template>
  <div class="plv-ia-aq-pre-start">
    <label class="plv-ia-aq-pre-start__time" :class="[{'plv-ia-aq-pre-start__time--warn': !hasTime}]">
      {{ t('plvIA.answerQuickly.responderTime') }}
      <input
        v-model="answerTime"
        type="text"
      />{{ t('plvIA.answerQuickly.seconds') }}
    </label>
    <div
      v-show="!hasTime"
      class="plv-ia-aq-pre-start__tip"
    >
      {{ t('plvIA.answerQuickly.cantEmptyTips') }}
    </div>
    <div class="plv-ia-aq-pre-start__btn">
      <button
        class="plv-ia-btn-new plv-ia-btn-blue"
        :disabled="!hasTime"
        @click="handleClickStartBtn"
      >
        {{ t('plvIA.answerQuickly.start') }}
      </button>
    </div>
  </div>
</template>
<script>
import Locale from '@/mixins/locale';
export default {
  mixins: [Locale],
  data() {
    return {
      answerTime: 30
    };
  },
  computed: {
    hasTime() {
      return !isNaN(Number(this.answerTime)) && this.answerTime > 0;
    }
  },
  watch: {
    answerTime(val, old) {
      const str = String(val);
      if (parseInt(val) === 0) {
        this.answerTime = 1;
      } else if (str.length > 2 || str.match(/\D/)) {
        this.answerTime = old;
      }
    }
  },
  methods: {
    handleClickStartBtn() {
      if (this.answerTime) {
        this.$emit('start', this.answerTime);
      }
    }
  },
};
</script>

<style lang="scss">
@import './mixins.scss';

.plv-ia-aq-pre-start {
  $inputH: 32px;
  font-size: 14px;
  @include mid;
  position: absolute;
  &__time {
    color: #606266;
    line-height: $inputH;
    input {
      width: 80px;
      height: $inputH;
      border-radius: 2px;
      border: 1px solid rgba(216, 216, 216, 1);
      color: #333;
      padding: 0 16px;
      display: inline-block;
      margin: 0 9px 0 15px;
      box-sizing: border-box;
      outline: none;
    }

    &--warn {
      input {
        background: rgba(255, 0, 0, 0.1);
        border-color: #FF5722;
      }
    }
  }
  &__tip {
    position: absolute;
    color: #FF5722;
    top: 45px;
    left: 75px;
    white-space: nowrap;

    &:before {
      content: '';
      display: inline-block;
      background: url(./images/tip.png) no-repeat;
      background-size: 14px;
      width: 14px;
      height: 14px;
      position: relative;
      top: 2px;
      margin-right: 10px;
    }
  }
}
.plv-ia-aq-pre-start__btn {
  padding-top: 40px;
  text-align: center;
}
</style>
